import "src/decidim/gallery/gallery"

require.context("../images", true)
